import * as yup from 'yup';

const regexSenha = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?![!@#$%&*-_+=[\]{}|:,.?^~<>();]).{8,25})$/;
// eslint-disable-next-line no-useless-escape
const regexEmail = /[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

const isEmailValidOrError = (email) => {
  // eslint-disable-next-line no-useless-escape
  const possuiApenasCaracterValido = (_email) => (_email.match(/[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/));
  if (!possuiApenasCaracterValido(email)) {
    throw new Error('O email informado é inválido');
  }

  const possuiMaximoCaracter = (_email) => (_email.length > 255);
  if (possuiMaximoCaracter(email)) {
    throw new Error('Informe no máximo 255 caracteres');
  }

  return true;
};

const isSenhaValidaOrError = (senha) => {
  const possuiCaracterMinusculo = (_senha) => (_senha.match(/[a-z]/g));
  if (!possuiCaracterMinusculo(senha)) {
    throw new Error('Informe ao menos uma letra minúscula');
  }

  const possuiCaracterMaiusculo = (_senha) => (_senha.match(/[A-Z]/g));
  if (!possuiCaracterMaiusculo(senha)) {
    throw new Error('Informe ao menos uma letra maiúscula');
  }

  const possuiNumero = (_senha) => (_senha.match(/[0-9]/g));
  if (!possuiNumero(senha)) {
    throw new Error('Informe ao menos um número');
  }

  const possuiMinimoCaracter = (_senha) => (_senha.length >= 8);
  if (!possuiMinimoCaracter(senha)) {
    throw new Error('Informe no mínimo 8 caracteres');
  }

  const possuiMaximoCaracter = (_senha) => (_senha.length > 25);
  if (possuiMaximoCaracter(senha)) {
    throw new Error('Informe no máximo 25 caracteres');
  }

  const possuiApenasCaracterValido = (_senha) => (_senha.match(/^[a-zA-Z0-9!@#$%&*-_+=[\]{}|:,.?^~<>();]*$/g));
  if (!possuiApenasCaracterValido(senha)) {
    throw new Error(`Caracteres inválidos: ${senha}`);
  }

  return true;
};

const validacaoSenhaYup = yup.object().shape({
  senha: yup
    .string()
    .min(8, 'Deve conter ao menos 8 caracteres')
    .max(25, 'Deve conter no máximo 25 caracteres')
    // eslint-disable-next-line func-names
    .test('regex senha', 'Tente uma senha mais forte', (senha) => (senha ? isSenhaValidaOrError(senha) : true)),
  // eslint-disable-next-line func-names
  confSenha: yup.string().test('confirmar_senha', 'Senhas não coincidem', function () {
    const { senha, confSenha } = this.parent;
    return senha ? senha === confSenha : true;
  }),
});

const validacaoEmailYup = yup.object().shape({
  email: yup
    .string()
    .max(80)
    .required('É necessário preencher o campo de e-mail')
    .test('regex email', 'O e-mail informado é inválido', (email) => (email ? isEmailValidOrError(email) : true)),
});

export {
  regexSenha,
  regexEmail,
  validacaoEmailYup,
  validacaoSenhaYup,
  isEmailValidOrError,
  isSenhaValidaOrError,
};
